// extracted by mini-css-extract-plugin
export var numberInputContainer = "_a0-0";
export var startPickingButton = "_a0-1";